import { isNative } from "./nativeHttp";

// The phone's status bar (clock, signal, battery) follows the app theme:
// light icons over the dark theme, dark icons over the light theme, and on
// Android the bar's background matches the page so the edge-to-edge margin
// never shows a mismatched strip. No-op on the web.
export async function syncStatusBar() {
  if (!isNative) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    const dark = document.body.classList.contains("dark");
    await StatusBar.setStyle({ style: dark ? Style.Dark : Style.Light });
    try {
      const bg = (getComputedStyle(document.body).getPropertyValue("--ion-background-color") || "").trim();
      await StatusBar.setBackgroundColor({ color: bg || (dark ? "#000000" : "#ffffff") });
    } catch { /* iOS has no background color to set */ }
  } catch { /* plugin unavailable: nothing to sync */ }
}
